import { $Enums } from '@vae/server/dist/client'
import { LocalTimeObject } from '@vae/server/src/interfaces/consumptionData.interface'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { getWeekString } from '../../../../modules/consumptionDataParser'
import { TimespanOption } from '../../chartUtils/hooks/useChartTime'

dayjs.extend(isoWeek)

const getTimeString = (
	selectedLocalTime: LocalTimeObject | null,
	selectedLabel: string,
	span: TimespanOption,
	language: $Enums.Language
) => {
	if (!selectedLocalTime) {
		return '-'
	}

	if (span === 'day') {
		return `${(selectedLocalTime?.hour ?? parseInt(selectedLabel)).toString().padStart(2, '0')}:${(selectedLocalTime?.minute ?? 0).toString().padStart(2, '0')}`
	} else if (span === 'week') {
		return getWeekString(selectedLocalTime?.weekDay ?? 0, language)
	} else if (span === 'month') {
		return `${selectedLabel}.${selectedLocalTime?.month}`
	} else if (span === 'year') {
		return selectedLabel
	} else {
		return '-'
	}
}

export default getTimeString
